import { Button, Tooltip } from '@dixa/lib-shared-habla';
import { useModal } from 'lib-knowledge-modal';

import { TestSettingsModal } from './testSettingsModal';

export function TestSettingsButton({
  versionId,
  name,
  hasUnsavedChanges,
}: {
  versionId: string | undefined;
  name: string | undefined;
  hasUnsavedChanges: boolean;
}): JSX.Element {
  const { showModal } = useModal();
  const disabledReason = hasUnsavedChanges
    ? 'Save your draft before testing it'
    : undefined;

  return (
    <Tooltip content={disabledReason} disabled={!disabledReason}>
      <Button
        variant="secondary"
        disabled={!!disabledReason}
        onClick={() => showModal(TestSettingsModal, { versionId, name })}
      >
        Test settings
      </Button>
    </Tooltip>
  );
}
